import React from "react";
import { FormattedMessage } from "react-intl";

export default [
    {
        name: "truckClass",
        label: <FormattedMessage id="truck-type.class" />,
        type: "select",
        helpText: <FormattedMessage id="truck-type.help-txt-class" />,
        errorMessage: <FormattedMessage id="truck-type.err-msg-class" />,
        data: [
            { value: "van", text: "Van" },
            { value: "dababa", text: "Dababa" },
            { value: "jumbo_5000", text: "Jumbo 5000" },
            { value: "jumbo_7000", text: "Jumbo 7000" },
            { value: "jumbo_8000", text: "Jumbo 8000" },
            { value: "lorry", text: "Lorry" },
            { value: "trella", text: "Trella" },
            { value: "trailer", text: "Trailer" },
            { value: "side_dump", text: "Side Dump" },
            { value: "carrier", text: "Carrier" },
        ],
        validation: {
            required: true,
        },
    },
    {
        name: "box",
        label: <FormattedMessage id="truck-type.box" />,
        type: "select",
        helpText: <FormattedMessage id="truck-type.help-txt-box" />,
        errorMessage: <FormattedMessage id="truck-type.err-msg-box" />,
        data: [
            { value: "opened", text: "Opened" },
            { value: "closed", text: "Closed" },
            { value: "flatbed", text: "Flatbed" },
            { value: "open_sided", text: "Open Sided" },
        ],
        validation: {
            required: true,
        },
    },
    {
        name: "condition",
        label: <FormattedMessage id="truck-type.condition" />,
        type: "select",
        helpText: <FormattedMessage id="truck-type.help-txt-condition" />,
        errorMessage: <FormattedMessage id="truck-type.err-msg-condition" />,
        data: [
            { value: "dry", text: "Dry" },
            { value: "colman", text: "Colman" },
            { value: "chilled", text: "Chilled" },
            { value: "frozen", text: "Frozen" },
            { value: "container_20_ft", text: "Container 20 ft" },
            { value: "container_40_ft", text: "Container 40 ft" },
            { value: "refrigerated", text: "Refrigerated" },
        ],
        validation: {
            required: true,
        },
    },
    {
        name: "capacityInTon",
        label: <FormattedMessage id="truck-type.capacity-in-ton" />,
        type: "number",
        helpText: <FormattedMessage id="truck-type.help-txt-capacity-in-ton" />,
        errorMessage: <FormattedMessage id="truck-type.err-msg-capacity-in-ton" />,
        validation: {
            required: true,
        },
    },
    {
        name: "numOfPallets",
        label: <FormattedMessage id="truck-type.pallets-count" />,
        type: "number",
        helpText: <FormattedMessage id="truck-type.help-txt-pallets-count" />,
        errorMessage: <FormattedMessage id="truck-type.err-msg-pallets-count" />,
        validation: {
            required: true,
        },
    },
];
